import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLspOnboarding } from "./lspSlice";
import { fetchServices } from "../../../components/global-entities/globalEntitiesSlice";

const useLspServices = () => {
  const dispatch = useDispatch();
  let { serviceList, activeIndex } = useSelector(
    (state) => state.lsponboarding,
  );
  const { entityservices } = useSelector((state) => state.globalEntities);

  useEffect(() => {
    dispatch(fetchServices());
  }, [dispatch]);

  const handleServiceChange = (id) => {
    let updatedServiceList;
    if (serviceList.some((service) => service.id === id)) {
      updatedServiceList = serviceList.filter((service) => service.id !== id);
    } else {
      const serviceToAdd = entityservices.find((service) => service.id === id);
      if (serviceToAdd) {
        updatedServiceList = [
          ...serviceList,
          { ...serviceToAdd, lsp_pay_url: "" },
        ];
      } else {
        updatedServiceList = [...serviceList];
      }
    }
    dispatch(
      setLspOnboarding({ key: "serviceList", value: updatedServiceList }),
    );
  };
  const handleServiceUpdate = (e, id) => {
    const updatedServiceList = serviceList.map((service) =>
      service.id === id ? { ...service, lsp_pay_url: e.target.value } : service,
    );
    dispatch(
      setLspOnboarding({ key: "serviceList", value: updatedServiceList }),
    );
  };

  useEffect(() => {
    handleEnableNext();
  }, [activeIndex, serviceList]);

  const handleEnableNext = () => {
    const urlPattern =
      /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})(\/\S*)?$/;

    if (activeIndex === 2) {
      if (
        serviceList &&
        serviceList.length > 0 &&
        serviceList.every((service) =>
          service.lsp_pay_url ? urlPattern.test(service.lsp_pay_url) : true,
        )
      ) {
        dispatch(
          setLspOnboarding({
            key: "nextBtnEnable",
            value: true,
          }),
        );
      } else {
        dispatch(
          setLspOnboarding({
            key: "nextBtnEnable",
            value: false,
          }),
        );
      }
    }
  };

  return {
    stateValues: {
      serviceList,
      entityservices,
    },
    handleServiceChange,
    handleServiceUpdate,
  };
};

export default useLspServices;
